import { render, staticRenderFns } from "./StrijkService.vue?vue&type=template&id=59fb407c&scoped=true"
import script from "./StrijkService.vue?vue&type=script&lang=js"
export * from "./StrijkService.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59fb407c",
  null
  
)

export default component.exports